<div class="select-box form-group">
  <!-- <label *ngIf="!!label" [innerHTML]="label"></label>
  <select
    id="general-select"
    class="form-control select"
    [ngClass]="{ loader: loading }"
    name="select"
    (change)="onChange($event)"
    (click)="onClick($event)"
    [value]="value"
    [disabled]="false"
  >
    <option
      *ngFor="let item of data"
      [selected]="initialValue == item?.name"
    ></option>
  </select> -->
  <mat-form-field appearance="fill">
    <mat-label>{{label}}</mat-label>
    <mat-select [(value)]="value">
      <mat-option
        *ngFor="let item of data"
        value="{{ item?.name }}"
        [selected]="initialValue == item?.name"
        ><span [innerHTML]="item?.description"></span
      ></mat-option>
    </mat-select>
   
  </mat-form-field>

  <span class="loader" *ngIf="loading">
    <img src="/assets/gifs/spinner.gif" alt="Icono Error" />
  </span>
</div>
